



export class WeryfikujZmianeAdresuEmailFormularz {
    public tokenPotwierdzajacy: string;
}
